import { Injectable } from "@angular/core";

import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";

import { EjendomService } from "@e-forsyning/common/ejendom";

import { EjendomsoplysningerViewModel } from "./model/ejendomsoplysninger.view-model";

@Injectable({ providedIn: "root" })
export class EjendomsoplysningerSandbox {
    constructor(private readonly ejendomService: EjendomService) {}

    public hentViewModel(): Observable<EjendomsoplysningerViewModel> {
        const ejendomsoplysninger$ = this.ejendomService.hentEjendomsoplysninger();

        return combineLatest([ejendomsoplysninger$]).pipe(map(([ejendomsoplysninger]) => ({ ejendomsoplysninger })));
    }
}
